import { Schema, Tcp } from "../../../../../@types";
import Name from "../../../../../../search/schema/components/Name";
import { enums } from "../../../../../../../shim/jsbridge";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const tcp: Schema<Tcp> = {
  fields: [
    {
      name: "src",
      displayTitle: "Source",
      sortable: true,
      component: (d: Tcp) => (
        <Name
          data={{
            file_name: d.src,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "sport",
      displayTitle: "Source port",
      sortable: true,
      component: (d: Tcp) => <>{d.sport}</>
    },
    {
      name: "dst",
      displayTitle: "Destination",
      sortable: true,
      component: (d: Tcp) => (
        <Name
          data={{
            file_name: d.dst,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "dport",
      displayTitle: "Destination port",
      sortable: true,
      component: (d: Tcp) => <>{d.dport}</>
    }
  ]
};
